var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingIcons({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6681 0.40416C11.8141 0.423222 11.9553 0.466988 12.0861 0.533066L12.213 0.606308C12.3771 0.714022 12.5146 0.857771 12.6154 1.02623C12.7146 1.19233 12.7749 1.37858 12.7931 1.57115H12.7941L12.7999 1.70299V7.34361L12.9611 7.37584L16.755 8.13658C16.9948 8.1844 17.2158 8.29799 17.3927 8.46471L17.465 8.5399C17.6509 8.74572 17.7663 9.00522 17.7941 9.28111L17.7999 9.41881V17.2001H19.0001C19.2038 17.2004 19.3998 17.2781 19.548 17.4178C19.6962 17.5578 19.786 17.7495 19.798 17.953C19.8099 18.1565 19.7433 18.3572 19.6124 18.5135C19.4817 18.6697 19.2961 18.7696 19.0939 18.7938L19.0001 18.7997H1.00012L0.849731 18.785C0.701622 18.7565 0.563491 18.6868 0.452271 18.5819C0.341189 18.477 0.262842 18.3432 0.225708 18.1971L0.202271 18.0467C0.193337 17.894 0.228546 17.7431 0.30188 17.6112L0.387817 17.4862C0.518202 17.3306 0.702926 17.2304 0.904419 17.2059L1.01184 17.2001H2.20032V4.36021C2.20032 3.84171 2.50675 3.37797 2.97473 3.17076L3.09778 3.12389L3.0968 3.12291L11.089 0.459824C11.2287 0.413321 11.3751 0.390953 11.5216 0.393417L11.6681 0.40416ZM10.9366 2.1981L3.93665 4.53111L3.79993 4.57701V17.2001H11.2003V2.11021L10.9366 2.1981ZM16.2003 9.65611L16.0392 9.62389L13.0392 9.02525L12.7999 8.9774V17.2001H16.2003V9.65611Z",
    fill: "white",
    stroke: "#5070DE",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingIcons);
export default __webpack_public_path__ + "static/media/buildingIcons.eadbd25cdda661ebad180ce0185c4929.svg";
export { ForwardRef as ReactComponent };